export default __webpack_public_path__ + "static/media/logs.b43cdb55.svg";